import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Main } from '../core/main.service';
import { TransactionService } from './transaction.service';
// import { Router } from '@angular/router';

@Component({
  selector: 'cp-transactions',
  templateUrl: './transactions.component.html',
})

export class TransactionsComponent {
  filter: string;
  typeFilter: string;
  statusFilter: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  transactions: any[];

  constructor(@Inject(Restangular) public Restangular, private mainService: Main, private api: TransactionService) {
    this.statusFilter = '';
    this.typeFilter = '';
    this.itemsPerPage = 10;
    this.totalItems = 0;
    this.currentPage = 1;
    this.getTransactionFilter();
  }

  getTransactionFilter() {
    this.filter = this.statusFilter + this.typeFilter;
    this.getTransactions();
  }

  getTransactions() {
    let j = this.itemsPerPage * this.currentPage - this.itemsPerPage;
    this.api.getTransactions('page=' + this.currentPage + this.filter).subscribe((resp: any) => {
      this.transactions = resp.data;
      for (let i = 0; i < this.transactions.length; i++) {
        this.transactions[i].no = j + 1;
        j++;
      }
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    }, (err) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'danger' });

    });
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getTransactions();
  }

  changeStatus(id: any, status: any) {
    this.api.changeTransactionStatus(id, status).subscribe((res: any) => {
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
      this.getTransactions();
    }, (err) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });

    });
  }

}
